import { Status } from './enums/status.enum';

export function isInvitedUser(status: string | null) {
  return (+status! as Status) === Status.Invited;
}
